import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SiteSettingsContext = createContext(null);

// Default settings for fallback
const defaultSettings = {
  contact: {
    address: 'NALCO Chowk, Semiliguda, Koraput, Odisha 764036, India',
    phones: ['+91 6372 350 065', '+91 9437 082 665'],
    email: 'thehotelemerald@gmail.com',
    whatsapp: '+916372350065'
  },
  google_maps: {
    latitude: '18.87',
    longitude: '82.82'
  },
  seo: {
    hotel_name: 'The Hotel Emerald',
    hotel_tagline: 'Luxury Hotel in Eastern Ghats',
    star_rating: '4',
    founding_year: '2020',
    price_range: '₹₹₹',
    instagram_url: 'https://www.instagram.com/thehotelemerald',
    facebook_url: 'https://www.facebook.com/thehotelemerald',
    tripadvisor_url: '',
    website_url: 'https://thehotelemerald.in',
    booking_url: 'https://thehotelemerald.in/book',
    languages_spoken: ['English', 'Hindi', 'Odia'],
    payment_methods: ['Cash', 'Credit Card', 'UPI'],
    check_in_time: '14:00',
    check_out_time: '11:00'
  }
};

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(defaultSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/site-settings`);
        setSettings(prev => ({
          ...prev,
          ...response.data,
          contact: { ...prev.contact, ...response.data.contact },
          google_maps: { ...prev.google_maps, ...response.data.google_maps },
          seo: { ...prev.seo, ...response.data.seo }
        }));
      } catch (error) {
        console.warn('Failed to fetch site settings, using defaults');
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ settings, loading }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    // Return default settings if not in provider (for backward compatibility)
    return { settings: defaultSettings, loading: false };
  }
  return context;
}

// Export default settings for use in schemas when context is not available
export { defaultSettings };
